import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import {
  MUISelect
} from 'components/FormHelpers/FormInputs';
import _ from 'lodash';
import {
  ListItem, ListItemText
} from '@material-ui/core';
import PropTypes from 'prop-types';


const PSRDropdownControl = ({
  name,
  textValue,
  handleDropdown,
  psrProtocolData,
  value,
  validators,
  errorMessages,
  isDisabled
}) => (
  <FormViewContent
    primaryText={textValue}
    secondaryText={(
      <MUISelect
        title={textValue}
        value={value}
        name={name}
        validators={validators}
        errorMessages={errorMessages}
        onChange={handleDropdown}
        disabled={isDisabled}
      >
        {_.map(psrProtocolData, (item, i) => (
          <ListItem
            button
            value={item.code}
            key={item.value}
          >
            <ListItemText
              primary={item.value}
            />
          </ListItem>
        ))}
      </MUISelect>
      )}
  />
);


PSRDropdownControl.propTypes = {
  name: PropTypes.string.isRequired,
  handleDropdown: PropTypes.func.isRequired,
  value: PropTypes.string,
  psrProtocolData: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.string
  })).isRequired,
  textValue: PropTypes.string.isRequired,
  validators: PropTypes.arrayOf(
    PropTypes.string
  ),
  errorMessages: PropTypes.arrayOf(
    PropTypes.string
  ),
  isDisabled: PropTypes.bool.isRequired
};

PSRDropdownControl.defaultProps = {
  validators: [],
  errorMessages: [],
  value: ''
};
export default PSRDropdownControl;
